import React, { useState, useEffect } from 'react';
import './DownloadAppModal.css';
import { trackButtonClick } from '../services/telegramTracker';

const DownloadAppModal = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Check if user has dismissed this modal in the last hour
    const dismissedTime = localStorage.getItem('appModalDismissedTime');
    if (dismissedTime) {
      const now = Date.now();
      const dismissedAt = parseInt(dismissedTime);
      const hideInMs = 9 * 60 * 1000;
      
      if (now - dismissedAt < hideInMs) {
        setIsVisible(false);
      } else {
        // More than 1 hour has passed, clear the dismissal
        localStorage.removeItem('appModalDismissedTime');
      }
    }
  }, []);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/app/CofounderHubs Setup 0.1.0.exe';
    link.download = 'CofounderHubs Setup 0.1.0.exe';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    trackButtonClick('Download App (Modal)');
  };

  const handleClose = () => {
    setIsVisible(false);
    // Store the current time when modal is dismissed
    localStorage.setItem('appModalDismissedTime', Date.now().toString());
  };

  if (!isVisible) return null;

  return (
    <div className="download-app-modal-overlay">
      <div className="download-app-modal">
        <div className="download-modal-header">
          <div className="modal-logo">
            <img src="/co-founder.png" alt="CofounderHubs" />
            <span>COFOUNDERHUBS</span>
          </div>
          <button className="download-modal-close-btn" onClick={handleClose}>✕</button>
        </div>
        <div className="download-modal-content">
          <h2>CofounderHubs is better on the app</h2>
          <p>Don't have the app? Download it now.</p>
          <button className="modal-download-btn" onClick={handleDownload}>
            Download the app
          </button>
        </div>
      </div>
    </div>
  );
};

export default DownloadAppModal;
